/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import GETUSERCLOSECHATS from "src/graphql/query/dashboard/FigureCards/getUserCloseChats";
import { useSnackbar as Snackbar } from "notistack";
import ClosedChatsImg from "src/assets/images/dashboard/closedChatsIcon.png";
import { UseDashboardContext } from "src/context/dashboard";
import { useLazyQuery, useSubscription } from "@apollo/client";
import CLOSEDCHATCOUNTSUBSCRIPTION from "src/graphql/subscriptions/dashboard/closedchatcountchanged";
import { safeJsonParse } from "src/utils/shared/safeJson";
import GeneralCard from "../GeneralCard";

const ClosedChats = () => {
  const contextData = UseDashboardContext();
  let storedAgentId: number = 0;
  let globalTimeFrame: string = "today";

  if (contextData) {
    ({ storedAgentId, globalTimeFrame } = contextData);
  }

  const [
    getClosedChats,
    { data: getUserCloseChatCounts, loading: getUserCloseChatCountsLoading },
  ] = useLazyQuery(GETUSERCLOSECHATS, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (storedAgentId) {
      getClosedChats({
        variables: {
          agentId: [storedAgentId],
          timeFrame: globalTimeFrame,
        },
      });
    }
  }, [storedAgentId, globalTimeFrame]);

  const [totalChat, setTotalChats] = useState<number>(0);
  const { enqueueSnackbar } = Snackbar();

  useEffect(() => {
    if (getUserCloseChatCounts && getUserCloseChatCounts.getUserClosedChats) {
      if (getUserCloseChatCounts.getUserClosedChats.success) {
        setTotalChats(getUserCloseChatCounts.getUserClosedChats.count);
      } else {
        enqueueSnackbar(getUserCloseChatCounts.getUserClosedChats.error, {
          variant: "error",
        });
      }
    }
  }, [getUserCloseChatCounts]);

  const {
    data: closedchatcountchangedSubscriptionResult,
    error: closedchatcountchangedSubscriptionError,
  } = useSubscription(CLOSEDCHATCOUNTSUBSCRIPTION);

  useEffect(() => {
    if (closedchatcountchangedSubscriptionError) {
      enqueueSnackbar(closedchatcountchangedSubscriptionError.message, {
        variant: "error",
      });
    }
  }, [closedchatcountchangedSubscriptionError]);

  useEffect(() => {
    if (
      closedchatcountchangedSubscriptionResult &&
      globalTimeFrame === "today"
    ) {
      const { count, agentId } = safeJsonParse<any>(
        closedchatcountchangedSubscriptionResult.closedchatcountchanged.result,
        { count: 0, agentId: null },
        "Closed Chats",
      );
      if (storedAgentId === Number(agentId)) setTotalChats(count);
    }
  }, [closedchatcountchangedSubscriptionResult]);

  return (
    <GeneralCard
      tourId="tour-dashboard-closed-card"
      cardImage={ClosedChatsImg}
      count={totalChat}
      loader={getUserCloseChatCountsLoading}
      dropDownValues={globalTimeFrame}
      hideDropdown
      title="Close Chats"
    />
  );
};

export default ClosedChats;
